import jsonData from './data.json';

const state = {
  jsonData: jsonData,
}

const getters = {
  getAll: (state) => {
    return state.jsonData
  },
}

export default {
    namespaced: true,
    state,
    getters
}